import { authModule as createAuthModule } from '@gravitano/vue-auth'
import { authOptions } from '~/authOptions'

export const authModule = createAuthModule(authOptions)
